<template>
    <div class="row">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('user_list')}}
                    </a>
                </li>
                <li v-if="loading">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12">
            <div class="d-flex align-items-center">
                <div class="py-3 mr-2 flex-grow-1">
                    {{$ml.get('Plan')}}: <strong>Premium</strong>
                </div>
                <div class="mr-2">
                    <a href="#!" @click.prevent="searchOpen = !searchOpen" v-if="!searchOpen">
                        <font-awesome-icon icon="search"/>&nbsp;&nbsp;{{(searchField ===
                        '')?$ml.get('Search'):searchField}}</a>
                    <input type="text"
                           v-else
                           class="form-control"
                           name="search"
                           :placeholder="$ml.get('Search')"
                           v-model="searchField"
                           v-click-outside="initiateSearch">
                </div>
                <div>
                    <router-link to="/dashboard/users/add" class="btn btn-outline-dark text-uppercase btn-sm">
                        <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('add')}}
                    </router-link>
                </div>
            </div>
        </div>


        <div class="col-12 pt-3">
            <div class="table-responsive">
                <table class="table qf-table">
                    <thead>
                    <tr>
                        <th><a href="#!" @click.prevent="changeSort('firstName')">{{$ml.get('Name')}}&nbsp;<font-awesome-icon
                                icon="chevron-down" v-if="pagination.orderBy === 'firstName'"
                                class="animate-all" :class="{'rotate180deg': (pagination.orderDirection === 'desc')}"/>
                        </a></th>
                        <th><a href="">{{$ml.get('Role')}}&nbsp;<font-awesome-icon icon="chevron-down"
                                                                                   v-if="pagination.orderBy === 'role'"
                                                                                   class="animate-all"
                                                                                   :class="{'rotate180deg': (pagination.orderDirection === 'desc')}"/>
                        </a></th>
                        <th>{{$ml.get('Active')}}</th>
                        <th class="qf-table-action"></th>
                        <th class="qf-table-action"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="loading">
                        <td colspan="4" class="p-5 h2 text-center">
                            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                        </td>
                    </tr>
                    <tr v-else-if="!users.length">{{$ml.get('no_users_added')}}</tr>
                    <tr v-else
                        v-for="(user, index) in filteredUsers"
                        :key="index">
                        <td class="py-3">{{user.first_name}} {{user.last_name}}</td>
                        <td class="py-3">{{getUserRole(user.roles[0])}}</td>
                        <td class="py-3">
                            <label class="qf-switch"
                                   :class="{'qf-cursor-not-allowed': statusLoaders.includes(user.id)}"
                                   @click.prevent="changeStatus(user.id)">
                                <input type="checkbox"
                                       name="monitoring"
                                       value="monitoring"
                                       v-model="user.enabled"
                                       :disabled="statusLoaders.includes(user.id)">
                                <span class="qf-switch-dot text-center"><font-awesome-icon icon="spinner"
                                                                                           class="fa-spin"
                                                                                           v-if="statusLoaders.includes(user.id)"/></span>
                                <span class="qf-switch-on">{{$ml.get('Yes')}}</span>
                                <span class="qf-switch-off">{{$ml.get('No')}}</span>
                            </label>
                        </td>
                        <td class="py-3 qf-table-action qf-big">
                            <router-link :to="`/dashboard/users/edit/${user.id}`">
                                <font-awesome-icon icon="pen"/>
                            </router-link>
                        </td>
                        <td class="py-3 qf-table-action qf-big">
                            <a href="#!" @click.prevent="deleteUser(user.id)">
                                <font-awesome-icon icon="trash-alt"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserList",
        computed: {
            filteredUsers() {
                if (this.searchField === '') {
                    return this.users;
                } else {
                    return this.users.filter(obj => {
                        return (obj.first_name.toLowerCase().includes(this.searchField.toLowerCase()) ||
                            obj.last_name.toLowerCase().includes(this.searchField.toLowerCase()));
                    })
                }
            }
        },
        data() {
            return {
                searchOpen: false,
                searchField: '',
                users: [],
                statusLoaders: [],
                pagination: {
                    orderBy: 'firstName',
                    orderDirection: 'asc',
                },
                loading: false,
            }
        },
        beforeMount() {
            this.getUsers();
        },
        methods: {
            changeStatus(id) {
                if (!this.statusLoaders.includes(id)) {
                    this.statusLoaders.push(id);
                    this.$store.dispatch('changeStatus', id).then(response => {
                        let userIndex = this.users.findIndex(obj => {
                            return obj.id === id;
                        });
                        if (userIndex > -1) {
                            this.users[userIndex].enabled = response.enabled;
                        }
                        this.removeFromStatusLoaders(id);
                    }).catch(() => {
                        this.removeFromStatusLoaders(id);
                    })
                }
            },
            removeFromStatusLoaders(id) {
                let statusLoaderIndex = this.statusLoaders.findIndex(item => {
                    return item === id;
                });
                if (statusLoaderIndex > -1) {
                    this.statusLoaders.splice(statusLoaderIndex, 1);
                }
            },
            getUsers() {
                if (!this.loading) {
                    this.loading = true;
                    this.$store.dispatch('users', this.pagination).then(response => {
                        this.loading = false;
                        this.users = response.users;
                    });
                }
            },
            getUserRole(role) {
                if (role === 'ROLE_WRITE') {
                    return 'Assistant'
                }
                if (role === 'ROLE_READ') {
                    return 'Trademark Owner'
                }
            },
            initiateSearch() {
                if (this.searchOpen) {
                    this.searchOpen = !this.searchOpen
                }
            },
            deleteUser(id) {
                this.$store.dispatch('deleteUser', id).then(() => {
                    this.users = [];
                    this.getUsers();
                });
            },
            changeSort(field) {
                if (!this.loading) {
                    if (this.pagination.orderBy === field) {
                        this.pagination.orderDirection = (this.pagination.orderDirection === 'asc') ? 'desc' : 'asc';
                    } else {
                        this.pagination.orderBy = field;
                        this.pagination.orderDirection = 'asc';
                    }
                    this.pagination.page = 0;
                    this.pagination.offset = 0;
                    this.getUsers();
                }
            },
        }
    }
</script>

<style scoped>

</style>
